import React from 'react';
import InfoField from './InfoField';
import { format } from 'date-fns';
import { Box } from '@mui/material';

const ContactInfo = ({ data }) => {
  return (
    <>
      <InfoField labelKey="FullName" value={data?.firstName ? `${data.firstName} ${data.lastName}` : '/'} />
      <InfoField labelKey="birthdate" value={data?.birthdate ? format(new Date(data?.birthdate), 'dd.MM.yyyy') : '/'} />
      <Box display="flex" flexDirection="row" width="100%" gap="10px">
        <InfoField labelKey="email" value={data?.email ? data?.email : '/'} />
        <InfoField labelKey="phone.number" value={data?.phoneNumber ? data?.phoneNumber : '/'} />
      </Box>
    </>
  );
};

export default ContactInfo;
